module.exports = __webpack_public_path__ + "media/images/iconbox/icon12-6d858a26542571c1375d8a591715b2b2.png";